module.exports = __webpack_public_path__ + "static/media/logo.0417b390.png";